import React from "react";
import { cn } from "../../../common/u1/cn";
import { toneClasses, ctaClasses } from "./tradeTones";

/* One product on a Trade vertical page. */
export const ProductCard = ({ card = {}, accent = "blue", onCta = () => {}, className = "" }) => {
  const feature = !!card.feature;
  const tone = toneClasses(card.tone || accent);

  return (
    <div
      className={cn(
        "rounded-[14px] border p-[22px] shadow-[0_1px_2px_rgba(0,0,0,.04)]",
        feature
          ? "col-span-full flex flex-row flex-wrap items-center gap-[30px] border-[var(--card-feature-line)] bg-[var(--card-feature-bg)]"
          : "flex flex-col border-[var(--card-line)] bg-white",
        className
      )}
    >
      <div className={cn("min-w-0", feature ? "flex-[1_1_360px] max-w-[660px]" : "grow basis-0")}>
        <div className="mb-3.5">
          <span
            className={cn(
              "inline-block whitespace-nowrap rounded-md px-[9px] py-1",
              "text-[11px] font-bold uppercase tracking-[.5px] font-sans",
              tone.tag
            )}
          >
            {card.tag}
          </span>
        </div>

        <h3 className="m-0 mb-1.5 text-[17px] font-bold text-[var(--navy)] font-sans">
          {card.title}
        </h3>

        <div className="text-[20px] font-bold tracking-[-.3px] text-[var(--navy)] font-sans">
          {card.price}
        </div>

        {card.memberRate && (
          <div className="mt-2 inline-flex items-center gap-1.5 rounded-[20px] bg-[var(--member-bg)] px-2.5 py-1 text-[12px] font-semibold text-[var(--member-text)] font-sans">
            <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-[var(--gold-star)]" />
            {card.memberRate}
          </div>
        )}

        <p className="mt-3.5 mb-0 text-[13.5px] leading-[1.55] text-[var(--trade-body)] font-sans">
          {card.body}
        </p>
      </div>

      <div
        className={cn(
          "flex",
          feature
            ? "shrink-0 flex-col items-start gap-[9px]"
            : "mt-[18px] flex-wrap items-center gap-[13px]"
        )}
      >
        <button
          type="button"
          onClick={() => onCta(card)}
          className={cn(
            "cursor-pointer rounded-[9px] px-[18px] py-2.5 text-[13.5px] font-bold font-sans",
            "transition-colors",
            ctaClasses(card.ctaKind)
          )}
        >
          {card.cta}
        </button>
        {card.micro && (
          <span className="text-[12px] text-[var(--trade-micro)] font-sans">{card.micro}</span>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
